import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import { getSessionSettingsStorage } from '../store/session-storage';
import { useRestaurant } from '../contexts/restaurant.context';
import { MenuItemModal } from './MenuItemModal';

const initialQuantity = 1;
const initialOptionQuantity = 1;
const initOfferDiscount = 0;
const initOfferQuantity = 0;

function SelectMenuItemDialog({ item, confirmLabel, onClose, onConfirm }) {
    const [quantity, setQuantity] = useState(initialQuantity);
    
    const [specialInstructions, setSpecialInstructions] = useState('');
    const [selectedOptions, setSelectedOptions] = useState({});
    const [confirmBtnDisabled, setConfirmBtnDisabled] = useState(false);

    const [offerDiscount, setOfferDiscount] = useState(initOfferDiscount);
    const [offerQuantity, setOfferQuantity] = useState(initOfferQuantity);

    const [isSpecialOffer, setIsSpecialOffer] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    
    const [clientName, setClientName] = useState('');

    const restaurant = useRestaurant();

    const { theme, is_hide_who_is_for, is_hide_spec_instructions } = restaurant;
    
    const requiredOptions = item ? item.options.filter((option) => option.is_required) : [];
    const notSelectedOptions = requiredOptions.filter((option) => !selectedOptions[option.id] || selectedOptions[option.id].option_labels.length === 0);
    
    const closeDialog = () => {
        setQuantity(initialQuantity);
        setSpecialInstructions('');
        setSelectedOptions({});
        setConfirmBtnDisabled(false);
        setOfferDiscount(initOfferDiscount);
        setIsSpecialOffer(false);
        setOfferQuantity(initOfferQuantity);
        
        onClose?.();
    };

    const handlerCloseClick = (e) => {
        e.preventDefault();

        if (e.target.closest('button.close') || e.target.classList.contains('modal')) {
            closeDialog();
        }
    };

    const handlerIncrement = (e) => {
        e.preventDefault();
        setQuantity(prevQty => prevQty + 1);
    };

    const handlerDecrement = (e) => {
        e.preventDefault();
        setQuantity(prevQty => prevQty > 1 ? prevQty - 1 : prevQty);
    };

    const handlerOptionIncrement = (e, optionGroup, option) => {
        e.preventDefault();

        const optionsQty = selectedOptions[optionGroup.id].option_labels.reduce((acc, cur) => acc + cur.quantity, 0);
        if (optionGroup.max_allowed_selection !== 0 && optionGroup.max_allowed_selection <= optionsQty) {
            return false;
        }

        setSelectedOptions(prevSelectedOptions => {
            const opt = prevSelectedOptions[optionGroup.id].option_labels.find(o => o.id === option.id);

            return {
                ...prevSelectedOptions,
                [optionGroup.id]: {
                    ...prevSelectedOptions[optionGroup.id],
                    option_labels: [
                        ...prevSelectedOptions[optionGroup.id].option_labels.filter(o => o.id !== option.id),
                        {
                            ...opt,
                            quantity: opt.quantity + 1
                        }
                    ]
                }
            };
        });
    };

    const handlerOptionDecrement = (e, optionGroup, option) => {
        e.preventDefault();

        setSelectedOptions(prevSelectedOptions => {
            const opt = prevSelectedOptions[optionGroup.id].option_labels.find(o => o.id === option.id);

            return {
                ...prevSelectedOptions,
                [optionGroup.id]: {
                    ...prevSelectedOptions[optionGroup.id],
                    option_labels: [
                        ...prevSelectedOptions[optionGroup.id].option_labels.filter(o => o.id !== option.id),
                        {
                            ...opt,
                            quantity: opt.quantity > 1 ? opt.quantity - 1 : opt.quantity
                        }
                    ]
                }
            };
        });
    };

    const handlerSelectOption = (e, optionGroup, option) => {
        if (option.is_sold_out) {
            return false;
        }

        const optionsQty = selectedOptions[optionGroup.id]
            ? selectedOptions[optionGroup.id].option_labels.reduce((acc, cur) => acc + (cur.quantity || 1), 0)
            : 0;

        if (
            'any' === optionGroup.input_type
            && selectedOptions[optionGroup.id]
            && optionGroup.max_allowed_selection !== 0
            && (
                !selectedOptions[optionGroup.id].option_labels.some((o) => o.id === option.id)
                // && optionGroup.max_allowed_selection <= selectedOptions[optionGroup.id].option_labels.length
                && optionGroup.max_allowed_selection <= optionsQty
            )
        ) {
            return false;
        }

        setSelectedOptions((prevSelectedOptions) => {
            let obj = {
                ...prevSelectedOptions,
            };

            if (!prevSelectedOptions[optionGroup.id] || 'one_of' === optionGroup.input_type) {
                obj[optionGroup.id] = {
                    ...optionGroup,
                    option_labels: [
                        {
                            ...option,
                            quantity: initialOptionQuantity
                        }
                    ]
                };
            }
            else if (!prevSelectedOptions[optionGroup.id].option_labels.some((o) => o.id === option.id)) {
                obj[optionGroup.id] = {
                    ...optionGroup,
                    option_labels: [
                        ...prevSelectedOptions[optionGroup.id].option_labels,
                        {
                            ...option,
                            quantity: initialOptionQuantity
                        }
                    ]
                };
            }
            else {
                obj[optionGroup.id] = {
                    ...optionGroup,
                    option_labels: [
                        ...prevSelectedOptions[optionGroup.id].option_labels.filter((o) => o.id !== option.id)
                    ]
                };
            }

            return obj;
        });
    };

    const handleItemConfirm = (e) => {
        e.preventDefault();

        const client_id = getSessionSettingsStorage('client_id');

        onConfirm?.({
            ...item,
            quantity,
            specialInstructions,
            selectedOptions,
            offerDiscount,
            offerQuantity,
            clientName,
            clientId: client_id,
        });

        closeDialog();
    };

    const handleChangeClientName = (e) => {
        setClientName(e.target.value);
    };
    
    useEffect(() => {
        setConfirmBtnDisabled(notSelectedOptions.length > 0);
    }, [selectedOptions, notSelectedOptions]);

    useEffect(() => {
        setIsSpecialOffer(
            (item && item.special_offer.discount_rate && item.special_offer.discount_rate > 0)
            || (item && item.special_offer.discount_value && item.special_offer.discount_value > 0)
        );

        item && setClientName(item.clientName || '');

        item && setQuantity(item?.quantity || initialQuantity);
        item && setOfferDiscount(item?.offerDiscount || initOfferDiscount);
        item && setSpecialInstructions(item?.specialInstructions || '');
        if (item && item.selectedOptions) {
            setSelectedOptions({...item.selectedOptions});
        }
    }, [item]);

    useEffect(() => {
        item && setTotalPrice((
            (
                item.price
                + Object
                    .entries(selectedOptions)
                    .map(([key, o]) => o.option_labels.reduce((acc, l) => acc + (l.quantity * l.price), 0))
                    .reduce((acc, p) => acc + p, 0)
            ) * quantity
        ).toFixed(2));

        if (isSpecialOffer && item.special_offer.quantity >= quantity) {
            if (item.special_offer.discount_rate > 0) {
                setOfferDiscount(totalPrice * (item.special_offer.discount_rate / 100));
            }
            if (item.special_offer.discount_value > 0) {
                setOfferDiscount(item.special_offer.discount_value * quantity);
            }
            setOfferQuantity(quantity);
        }
    }, [quantity, item, selectedOptions]);
    
    if (!item) {
        return null;
    }

    return (
        <MenuItemModal isOpen={!!item}>
            <MenuItemModal.Header>
                <button type="button" className="close" aria-label="Close" onClick={handlerCloseClick}>
                    Close&nbsp;
                    <span aria-hidden="true">
                        <i className="fas fa-times" style={{fontSize: '25px'}}></i>
                    </span>
                </button>

                {item.image_url.length > 0 && (
                    <div className="card-head-image item-image d-flex pb-2">
                        <img className="card-img-top card-item-image"
                             src={item.image_url}
                             data-holder-rendered="true"
                        />
                    </div>
                )}

                <div className="flex-box">
                    <h5 className="menu-item-name">
                        {item.name}{isSpecialOffer && (<span className="sold-out pl-1">(Special Offer)</span>)}
                        {item.spicy_level > 0 && (
                            <span className="pl-2 text-danger">
                                                {[...Array(item.spicy_level)].map((i) => (<i className="fas fa-pepper-hot"></i>))}
                                            </span>
                        )}
                    </h5>
                    <h5 className="menu-item-price" style={{color: theme.popup_item_price_font_color}}>${(item.price || 0).toFixed(2)}</h5>
                    {/*{offerDiscount === 0 && (*/}
                    {/*    <h5 className="menu-item-price" style={{color: theme.popup_item_price_font_color}}>${totalPrice}</h5>*/}
                    {/*)}*/}
                    {/*{offerDiscount > 0 && (*/}
                    {/*    <h5 className="menu-item-price"><s className="text-muted">${totalPrice}</s> <span style={{color: theme.popup_item_price_font_color}}>${(totalPrice - offerDiscount).toFixed(2)}</span></h5>*/}
                    {/*)}*/}
                </div>

                {item.description && (
                    <p className="menu-item-description">{item.description}</p>
                )}

                {isSpecialOffer && item.special_offer.quantity && (
                    <p className="menu-item-description">
                        <span className="menu-item-price">{item.special_offer.quantity}</span> items remaining at special price
                    </p>
                )}
            </MenuItemModal.Header>
            
            <MenuItemModal.Body>
                <div className="menu-item-options">

                    {item.options.map((option, index) => (

                        <div className={classNames('item-option', {required: option.is_required})} key={index}>
                            <h5 className="option-title pt-3 pb-3 pl-2">{option.name}</h5>
                            {/*{'one_of' === option.input_type ? (*/}
                            {/*    <small className="">Select one item.</small>*/}
                            {/*) :(*/}
                            {/*    <small className="">Select as many as you want.</small>*/}
                            {/*)}*/}

                            <div className="row">

                                {option.option_labels.map((label, indexL) => (

                                    <div className="col-md-12" key={`${index}_${indexL}`}>

                                        {'one_of' === option.input_type ? (

                                            <div className="custom-control custom-radio option">
                                                <input type="radio"
                                                       className="custom-control-input"
                                                       name={`options[${label.id}]`}
                                                       value={label.id}
                                                       checked={selectedOptions[option.id] && selectedOptions[option.id].option_labels.some((o) => o.id === label.id)}
                                                       itemID={`r_${index}_${indexL}_${label.id}`}/>
                                                <label
                                                    onClick={(e) => { handlerSelectOption(e, option, label) }}
                                                    className={classNames('custom-control-label', {info: label.is_informational})}
                                                    htmlFor={`r_${index}_${indexL}_${label.id}`}>{label.name}{label.is_sold_out && (<span className="sold-out pl-1">(Sold Out)</span>)}</label>
                                                <span className={classNames('price float-right', {'d-none': label.is_informational})}>${((selectedOptions[option.id] && selectedOptions[option.id].option_labels.some((o) => o.id === label.id) ? selectedOptions[option.id].option_labels.find((o) => o.id === label.id).quantity : 1) * label.price).toFixed(2)}</span>
                                                {label.description && (<p className={'mt-2'} style={{fontWeight: 'normal'}}>{label.description}</p>)}
                                            </div>

                                        ) :(

                                            <div className="custom-control custom-checkbox option">
                                                <input type="checkbox"
                                                       className="custom-control-input"
                                                       name={`options[${label.id}][]`}
                                                       value={label.id}
                                                       checked={selectedOptions[option.id] && selectedOptions[option.id].option_labels.some((o) => o.id === label.id)}
                                                       itemID={`c_${index}_${indexL}_${label.id}`}/>
                                                <label
                                                    onClick={(e) => { handlerSelectOption(e, option, label) }}
                                                    className={classNames('custom-control-label', {info: label.is_informational})}
                                                    htmlFor={`c_${index}_${indexL}_${label.id}`}>{label.name}{label.is_sold_out && (<span className="sold-out pl-1">(Sold Out)</span>)}</label>
                                                <span className={classNames('price float-right', {'d-none': label.is_informational})}>${((selectedOptions[option.id] && selectedOptions[option.id].option_labels.some((o) => o.id === label.id) ? selectedOptions[option.id].option_labels.find((o) => o.id === label.id).quantity : 1) * label.price).toFixed(2)}</span>
                                                {label.description && (<p className={'mt-2'} style={{fontWeight: 'normal'}}>{label.description}</p>)}
                                            </div>

                                        )}

                                        {(option.input_type !== 'any' || !option.is_hide_counter) && selectedOptions[option.id] && selectedOptions[option.id].option_labels.some((o) => o.id === label.id) && selectedOptions[option.id].max_allowed_selection !== 1 && (
                                            <div className="menu-item-option-qty mb-4 d-flex justify-content-center">
                                                <a href="#" className="item-option-qty-trigger" id="subOptionQuantity" onClick={(e) => handlerOptionDecrement(e, option, label)}>
                                                    <i className="fas fa-minus"></i>
                                                </a>
                                                <div className="item-option-qty" id="itemOptionQuantity">{selectedOptions[option.id].option_labels.find((o) => o.id === label.id).quantity}</div>
                                                <a href="#" className="item-option-qty-trigger" id="addOptionQuantity" onClick={(e) => handlerOptionIncrement(e, option, label)}>
                                                    <i className="fas fa-plus"></i>
                                                </a>
                                            </div>
                                        )}

                                    </div>

                                ))}

                            </div>
                        </div>

                    ))}

                    <hr/>

                    {!is_hide_who_is_for && (
                        <div className="form-group">
                            <label
                                htmlFor="group_client_name"
                                className="item-qty-title pt-3 pb-3 pl-2 w-100"
                            >
                                Name of person this is for? (optional entry)
                            </label>
                            <input
                                type="text"
                                id="group_client_name"
                                className="form-control"
                                value={clientName}
                                onChange={handleChangeClientName}
                            />
                        </div>
                    )}

                    {!is_hide_spec_instructions && (
                        <div className="form-group">
                            <label className="item-qty-title pt-3 pb-3 pl-2 w-100">
                                Special Requests
                            </label>
                            <p className="text-muted">
                                We cannot accept price-altering changes here.
                            </p>
                            <textarea className="form-control no-resize"
                                      placeholder="Special instructions"
                                      value={specialInstructions}
                                      onChange={(e) => setSpecialInstructions(e.target.value)}
                            ></textarea>
                        </div>
                    )}
                </div>
                
                <div className="d-flex flex-column justify-content-center">
                    <span className="text-center mb-3">Total Order Count</span>

                    <div className="menu-item-qty mb-4 d-flex justify-content-center">
                        <a href="#" className="item-qty-trigger" id="subQuantity" onClick={handlerDecrement}>
                            <i className="fas fa-minus"></i>
                        </a>
                        <div className="item-qty" id="itemQuantity">{quantity}</div>
                        <a href="#" className="item-qty-trigger" id="addQuantity" onClick={handlerIncrement}>
                            <i className="fas fa-plus"></i>
                        </a>
                    </div>
                </div>
            </MenuItemModal.Body>
            
            <MenuItemModal.Footer>
                <button type="button"
                        className="btn btn-primary btn-block btn-red"
                        onClick={handleItemConfirm}
                        disabled={confirmBtnDisabled}
                        style={{
                            color: theme.popup_item_button_font_color,
                            backgroundColor: theme.popup_item_button_background_color,
                            borderColor: theme.popup_item_button_background_color,
                        }}
                >
                    {confirmLabel}: ${totalPrice}
                </button>
            </MenuItemModal.Footer>
        </MenuItemModal>
    );
}

export default SelectMenuItemDialog;